<div class="custom-button" [ngClass]="[type, stateClass, size, color]" [class.disabled]="!state"
    (click)="onClickHandler()">
    <ng-container *ngIf="leftIcon">
        <img class="left-icon" [src]="leftIcon" alt="Left Icon" />
    </ng-container>
    <span *ngIf="textVisible">{{ text }}</span>
    <ng-container *ngIf="rightIcon">
        <img class="right-icon" [src]="rightIcon" alt="Right Icon" />
    </ng-container>
</div>